// extracted by mini-css-extract-plugin
module.exports = {"scrollBody":"scrollBody-1KjEp","modal":"modal-1-H6U","closeIcon":"closeIcon-te75K","warningModal_header":"warningModal_header-3HRK0"};